import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../config/axios';

export const useVisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const referrer = document.referrer || '';
    const SESSION_KEY = 'temple_session_id';
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    let heartbeatInterval = null;

    const trackPageHit = async () => {
      try {
        const response = await api.post('/api/analytics/hit', {
          sessionId: sessionId || undefined,
          pagePath,
          referrer
        });

        if (response.data && response.data.sessionId) {
          sessionId = response.data.sessionId;
          sessionStorage.setItem(SESSION_KEY, sessionId);
        }

        // Start heartbeat pings every 10 seconds to calculate duration
        if (heartbeatInterval) clearInterval(heartbeatInterval);
        
        heartbeatInterval = setInterval(async () => {
          if (!sessionId) return;
          try {
            await api.post('/api/analytics/ping', {
              sessionId,
              pagePath
            });
          } catch (pingError) {
            // Silently fail pings to avoid user disruption
            console.warn('Heartbeat ping failed:', pingError.message);
          }
        }, 10000); // 10 seconds

      } catch (error) {
        console.error('Failed to log page hit:', error.message);
      }
    };

    trackPageHit();

    return () => {
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
      }
    };
  }, [location]);
};

export default useVisitorTracker;
